import { Injectable } from '@angular/core';
import { WidgetsContainerAbstract } from 'src/app/abstract/widgets/widgets-container.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { Logger } from 'src/app/core/logger';
import { Config } from 'src/app/config';
import { getKeyFromText } from '../shared/camelCase';
import { WidgetsTimeRangeModel } from 'src/app/models/widgets/widgets-time-range.model';
import { capitalize } from '@angular-devkit/core/src/utils/strings';

@Injectable({
  providedIn: 'root',
})
export class WidgetsDatapointsService {
  constructor(
    private logger: Logger) {
    // Empty
  }

  /**
   * This method traverses the layout tree and each time it finds
   * a node with a key, it adds it to the keyList.
   * Exceptions:
   * - not for questions
   * - not for sections
   *
   * @param keyList
   * @param widget
   * @returns
   */
  public async getDataPointsList(
    keyList: string[],
    widget: WidgetsAbstract,
    index: number
  ): Promise<void> {
    // Check if this node has a key property
    if (widget.hasOwnProperty('key') &&
      widget.widgetType !== WidgetsTypeEnum.SECTION &&
      widget.widgetType !== WidgetsTypeEnum.QUESTION) {
      /* eslint-disable @typescript-eslint/dot-notation */
      if (widget['options'] && widget['key'] && widget['type']!== 'select') {
        // For Widgets with options (radio, checkbox, select,...)
        const options = widget['options'];

        try {
          options.forEach(element => {
            let keyName: string = '';
            if (element['label'] && element['value']) {
              // Formly > V5.5: We receive label ("Not Available") and value ("NA")
              keyName = element['value'] ? element['value'] : getKeyFromText(element['label']);
            } else if (element['key']) {
              // NgxFormly: legacy select option '{key, value}' is deprecated since v5.5, use '{value, label}' instead.
              keyName = element['value'] ? element['value'] : getKeyFromText(element['key']);
            }
            if(widget.hasOwnProperty('isExtended')){
              keyName = keyName;    // Extended Checkbox Key name without appending initial Key
            }else{
              keyName = widget['key'] + keyName;    // concat the key of the primitive AND the option
            }            
            keyList.push(keyName);
          });
        } catch (ignore) { }

        if (widget['otherFlag']) {
          const otherFlag: boolean = widget['otherFlag'] as boolean;
          if (otherFlag) {
            keyList.push(widget['key'] + Config.CONSTANTS.otherKeySuffix);
            if (widget['otherKey']) {
              keyList.push(widget['otherKey'])
            } else {
              keyList.push(widget['key'] + capitalize(Config.CONSTANTS.otherDescription));
            }
          }
        }
      } else if (widget instanceof WidgetsTimeRangeModel && widget['key'] && widget['suffixFrom'] && widget['suffixTo'] && widget['suffixDays']) {
        // For TimeRange Primitives - add from To and Days
        ++index;
        keyList.push(widget['key'].replace(index.toString(), '') + widget['suffixFrom']);
        keyList.push(widget['key'].replace(index.toString(), '') + widget['suffixTo']);
        keyList.push(widget['key'].replace(index.toString(), '') + widget['suffixDays']);
      } else if (widget.widgetType === 23) {
        if (widget['sequenceNumberKey'] && widget['sequenceNumberKey'] !== '') {
          keyList.push(widget['sequenceNumberKey']);
        } else {
          keyList.push(widget['key'] + 'From');
        }
        if (widget['totalNumberKey'] && widget['totalNumberKey'] !== '') {
          keyList.push(widget['totalNumberKey']);
        } else {
          keyList.push(widget['key'] + 'To');
        }
      }
      else if (widget['key']) {
        keyList.push(widget['key']);
        // To insert at the beginning of the array
        // keyList.unshift(container.id);
      }
      /* eslint-enable */
    }

    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      container.children.forEach((childWidget, ind) => {
        this.getDataPointsList(keyList, childWidget, ind);
      });
    }

    // Extract keys for pure formly question only 
    if (widget.template) {

      // parse json template
      const formlyTemplate = JSON.parse(widget.template);

      // if @formlyTemplate contain fieldGroup, it's mean it is a pure formly question.
      // if pure formly question extract keys & push in keyList.
      formlyTemplate?.fieldGroup?.forEach( field => { 

        // It will run if @field contain nested filedGroup or row
        if(field.fieldGroup){
          field?.fieldGroup?.forEach(fieldGroup => {
            fieldGroup?.fieldGroup?.forEach( field => {
                if(field?.key){
                  keyList.push(field.key); 
                  if(field?.templateOptions?.options){
                    keyList.push(...this.makeKeyFromOptionArray(field)); 
                  }
                
                }
              })
          })
        }
        
        // It will run if @field DOES NOT contain nested filedGroup or row
        else if(field?.key){
          keyList.push(field.key); 
          if(field?.templateOptions?.options){
            keyList.push(...this.makeKeyFromOptionArray(field)); 
          }
        }
      })
    }
  }


  // /**
  //   if a @filed has options array than extract value from option object & concate with parent key to make a prover key.
  //   Concate options  value in parent key (line no 127)
  //   Example of option : 
  //    "options": [
  //                   {
  //                       "value": "Yes",
  //                       "label": "Yes",
  //                   },
  //                   {
  //                       "value": "NA",
  //                       "label": "N/A",
  //                   }
  //               ]
  // **/ 
    makeKeyFromOptionArray(field){    
     const options = field?.templateOptions?.options;
     if(options){       
         // Becasue checkbox input does not have the key attribute, so it key is not availabke pick value as key.
         const optionsKeys = options.map( option_ => field.key + option_.value );  
         return optionsKeys;       
     }
  }
}
